import vn from './vn.json';
import en from './en.json';

export default {
  en,
  vn,
};
